<template>
  <QuoteEmbeddable v-model="form"/>
</template>
<script>
import businessQuoteEmbeddableMixin from "@/mixins/embeddable/business/businessQuoteEmbeddableMixin";

export default {
  name: 'Quote',
  mixins: [businessQuoteEmbeddableMixin],
  data() {
    return {
      form: {},
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>